import React from "react";
import ListItem from "src/components/lists/list-items/ListItem";
import useGet from "src/hooks/rest/useGet";
import qs from "query-string";
import { useTranslation } from "react-i18next";

type TodoListType = "payments" | "envelopes" | "tasks" | "messages";

interface TodoListProps {
	items: TodoListType[];
}

const TodoList = ({ items }: TodoListProps) => {
	const { t } = useTranslation("lists", {
		keyPrefix: "todo-list",
	});
	const q = qs.stringify(
		{
			with: items,
		},
		{
			arrayFormat: "bracket",
		}
	);
	const [{ data }, loading] = useGet(`/todo?${q}`);
	return (
		<div className="flex flex-col gap-4">
			{items?.includes("envelopes") && (
				<ListItem to="/envelopes">
					<ListItem.Icon
						variant={
							loading || data?.envelopes > 0 ? "dark" : "green"
						}
						name="fas fa-file-signature"
					/>
					<ListItem.Content>
						<ListItem.Title {...{ loading }}>
							{t("agreements.title")}
						</ListItem.Title>
						<ListItem.Text {...{ loading }}>
							{t("agreements.text", {
								count: data?.envelopes || 0,
							})}
						</ListItem.Text>
					</ListItem.Content>
				</ListItem>
			)}
			{items?.includes("payments") && (
				<ListItem to="/payments">
					<ListItem.Icon
						variant={
							loading || data?.payments > 0 ? "dark" : "green"
						}
						name="fas fa-file-invoice"
					/>
					<ListItem.Content>
						<ListItem.Title {...{ loading }}>
							{t("payments.title")}
						</ListItem.Title>
						<ListItem.Text {...{ loading }}>
							{t("payments.text", {
								count: data?.payments || 0,
							})}
						</ListItem.Text>
					</ListItem.Content>
				</ListItem>
			)}
			{items?.includes("tasks") && (
				<ListItem to="/tasks">
					<ListItem.Icon
						variant={loading || data?.tasks > 0 ? "dark" : "green"}
						name="fas fa-file"
					/>
					<ListItem.Content>
						<ListItem.Title {...{ loading }}>
							{t("tasks.title")}
						</ListItem.Title>
						<ListItem.Text {...{ loading }}>
							{t("tasks.text", {
								count: data?.tasks || 0,
							})}
						</ListItem.Text>
					</ListItem.Content>
				</ListItem>
			)}
			{items?.includes("messages") && (
				<ListItem to="/inbox">
					<ListItem.Icon
						variant={
							loading || data?.messages > 0 ? "dark" : "green"
						}
						name="fas fa-comments"
					/>
					<ListItem.Content>
						<ListItem.Title {...{ loading }}>
							{t("messages.title")}
						</ListItem.Title>
						<ListItem.Text {...{ loading }}>
							{t("messages.text", {
								count: data?.messages || 0,
							})}
						</ListItem.Text>
					</ListItem.Content>
				</ListItem>
			)}
		</div>
	);
};

TodoList.defaultProps = {
	items: ["payments", "envelopes", "tasks", "messages"],
};

export default TodoList;
